<div class="audit-query-detail-container">
  <app-detail-main-template>
    <div container-header>
      <app-audit-query-header [stateName]="stateName" (currentTab)="onSelectTab($event)"></app-audit-query-header>
    </div>
    <div container-body>
      <div class="section tabContent" [hidden]="selectedTab !== 'auditquery'">
        <div class="grid-container">
          <div *ngIf="!showGrid" class="placeholder-container">
            <div class="placeholder-message">
              <h3>Configure filters and click Apply</h3>
              <p>Select required fields and click Apply to view the audit query grid.</p>
            </div>
          </div>
          <div *ngIf="showGrid && isQualityProjectType">
            <app-audit-query-grid [stateName]="stateName"></app-audit-query-grid>
          </div>
          <div [style.display]="showGrid && isRiskProjectType ? 'block' : 'none'">
            <app-audit-query-grid-risk></app-audit-query-grid-risk>
          </div>
        </div>
        <div class="package-generate-container">
          <div [style.display]="showGrid && isQualityProjectType ? 'block' : 'none'">
            <app-audit-package-generate></app-audit-package-generate>
          </div>
          <div [style.display]="showGrid && isRiskProjectType ? 'block' : 'none'">
            <app-audit-package-generate-risk></app-audit-package-generate-risk>
          </div>
        </div>
      </div>

      <div class="section tabContent" [hidden]="selectedTab !== 'chart'">
        <div *ngIf="isQualityProjectType" class="chart-container">
          <app-audit-query-chart></app-audit-query-chart>
        </div>
        <div *ngIf="isRiskProjectType" class="chart-container">
          <app-audit-query-chart-risk></app-audit-query-chart-risk>
        </div>
      </div>
    </div>
  </app-detail-main-template>
</div>
